"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BackupAction;

(function (BackupAction) {
  BackupAction["create"] = "C";
  BackupAction["delete"] = "D";
  BackupAction["update"] = "U";
})(BackupAction = exports.BackupAction || (exports.BackupAction = {}));